import type { SVGProps } from "react";
export default function SvgCircleCheck(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-circle-check-big-icon lucide-circle-check-big"
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="M21.801 10A10 10 0 1 1 17 3.335" />
			<path d="m9 11 3 3L22 4" />
		</svg>
	);
}
